import { PropType, defineComponent } from 'vue';

import { ITextValue } from '@/types/common';
import { IParsedVCardData } from '@/bundles/Contact/interfaces/IVCardParsedObj';

import VCardImportFormSection from '@/bundles/Contact/components/vcard/VCardImportFormSection.vue';
import VCardImportSelect from '@/bundles/Contact/components/vcard/VCardImportSelect.vue';

export const VCardSectionMixin = defineComponent({
  components: { VCardImportSelect, VCardImportFormSection },

  props: {
    modelValue: {
      type: Object as PropType<IParsedVCardData>,
      required: true,
    },
    items: {
      type: Array as PropType<ITextValue<string>[]>,
      default: () => [],
    }
  },

  emits: ['update:modelValue'],

  computed: {
    parsedData: {
      get (): IParsedVCardData {
        return this.modelValue;
      },
      set (value: IParsedVCardData) {
        this.$emit('update:modelValue', value);
      }
    },
  }
});
